import React from 'react';
import Popup from '../Popup'
import Grid from '@mui/material/Grid2';

export default function ReactivateForm(props) {
    return (
        <Popup
          closeButton
          onClose={()=>props.onClose(false)}
          title={props.lan.reactivateForm}
          icon='alert-icon.svg'
          buttonText={props.lan.reactivateForm}
          buttonOnClick={props.reactivateForm}>
          <Grid container>
            <Grid size={12} className='mt-2 Fielder-pink-color'>
              {props.lan.reactivateFormWarning}
            </Grid>
          </Grid>
        </Popup>
    )
}
